import { createMuiTheme } from '@material-ui/core';

// A custom theme for this app
export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#1465C0',
    },
    secondary: {
      main: '#2196F3',
    },
    error: {
      main: '#F44336',
    },
    success: {
      main: '#43A047',
    },
    background: {
      default: '#f7f9fc',
    },
  },
});
